(() => {
  'use strict';

  if (window.__soocasBundleOfferCardInitialized) return;
  window.__soocasBundleOfferCardInitialized = true;

  const cardSelector = '[data-bundle-offer-card]';

  const updateCard = (wrapper) => {
    const controls = wrapper.closest('.pb-box-250321, .purchase-main');
    const input = controls?.querySelector('#quantity-input');
    const card = wrapper.querySelector('.bundle-offer-card');
    const title = wrapper.querySelector('[data-bundle-offer-title]');
    const text = wrapper.querySelector('[data-bundle-offer-text]');

    if (!input || !card || !title || !text) return;

    const quantity = Number(input.value) || 1;
    const minimum = Number(wrapper.dataset.minQuantity) || 2;
    const isUnlocked = quantity >= minimum;
    const nextTitle = isUnlocked ? wrapper.dataset.unlockedTitle : wrapper.dataset.defaultTitle;
    const nextText = isUnlocked ? wrapper.dataset.unlockedText : wrapper.dataset.defaultText;

    card.classList.toggle('is-unlocked', isUnlocked);
    wrapper.dataset.bundleOfferState = isUnlocked ? 'unlocked' : 'default';

    if (title.textContent !== nextTitle) title.textContent = nextTitle || '';
    if (text.textContent !== nextText) text.textContent = nextText || '';
  };

  const scheduleUpdate = (wrapper) => {
    window.requestAnimationFrame(() => updateCard(wrapper));
  };

  const bindCard = (wrapper) => {
    if (wrapper.dataset.bundleOfferBound === 'true') return;

    const controls = wrapper.closest('.pb-box-250321, .purchase-main');
    if (!controls) return;

    wrapper.dataset.bundleOfferBound = 'true';

    controls.addEventListener('click', (event) => {
      if (event.target.closest('.quantity-btn') || event.target.closest('[data-costco-set]')) {
        scheduleUpdate(wrapper);
      }
    });

    controls.addEventListener('input', (event) => {
      if (event.target.matches('#quantity-input')) scheduleUpdate(wrapper);
    });

    controls.addEventListener('change', (event) => {
      if (event.target.matches('#quantity-input')) scheduleUpdate(wrapper);
    });

    controls.addEventListener('variant:change', () => scheduleUpdate(wrapper));
    controls.addEventListener('product:variant-change', () => scheduleUpdate(wrapper));

    updateCard(wrapper);
  };

  const initializeAll = (root = document) => {
    if (root.matches?.(cardSelector)) bindCard(root);
    root.querySelectorAll?.(cardSelector).forEach(bindCard);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
